<template>
    <div class="page-banner-setting-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">積分管理</div>
            <div class="breadcrumb-item">門店充值積分-新增/修改</div>
        </div>
        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row>
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>積分</span>
                                        </div>
                                        <Input v-model="form.credit"/>
                                    </FormItem>
									<FormItem>
									    <div slot="label" class="form-label">
									        <em class="red">* </em>
									        <span>價格</span>
									    </div>
									    <Input v-model="form.price"/>
									</FormItem>
									<FormItem>
									    <div slot="label" class="form-label">
									        <em class="red">* </em>
									        <span>贈送積分</span>
									    </div>
									    <Input v-model="form.extra_credit"/>
									</FormItem>
									<FormItem>
									    <div slot="label" class="form-label">
									        <em class="red">* </em>
									        <span>贈送積分有效天數</span>
									    </div>
									    <Input v-model="form.extra_credit_day"/>
									</FormItem>
									<FormItem>
									    <div slot="label" class="form-label">
									        <em class="red">* </em>
									        <span>排序</span>
									    </div>
									    <Input v-model="form.sort"/>
									</FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <span>類型</span>
                                        </div>
                                        <span>門店充值</span>
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">確認添加</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                isSubmiting: false,
                form: {
                    credit: '',
                    price: '',
                    extra_credit: '',
                    extra_credit_day: '',
					sort: ''
                }
            };
        },
        mounted()
        {
            this.pageParam = this.$route.query;
			if(this.pageParam.id != undefined) {
				this.getDetail();
			}
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            getDetail()
            {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.creditEdit + '/' + this.pageParam.id,
                    method: 'get',
                }).then((res) =>{
                    this.isSubmiting = false;
                    if (res.code == 0){
                        let resData = res.data;
                        this.form = {
                            credit: resData.credit,
                            price: resData.price,
                            extra_credit: resData.extra_credit,
                            extra_credit_day: resData.extra_credit_day,
							sort: resData.sort,
                            is_online: 2,
                        };
                    }
                }).catch((err) =>{
                    this.isSubmiting = false;
                });
            },
            handleCheckForm()
            {
                let form = this.form;
                if (form.credit === '')
                {
                    this.$Utils.showTipInfo('請輸入積分');
                    return;
                } else if (form.price === '')
                {
                    this.$Utils.showTipInfo('請輸入價格');
                    return;
                } else if (form.extra_credit === '')
                {
                    this.$Utils.showTipInfo('請輸入贈送積分');
                    return;
                }else if (form.extra_credit_day === '')
                {
                    this.$Utils.showTipInfo('請輸入贈送積分有效天數');
                    return;
                }else if (form.sort === '')
                {
                    this.$Utils.showTipInfo('請輸入排序');
                    return;
                }
				
				this.handleSubmit();
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;
				if(this.pageParam.id != undefined) {
					this.$Rq.requestAuth({
					    url: this.$Api.creditEdit + '/' + this.pageParam.id,
					    method: 'post',
					    data: {
					        credit: form.credit,
					        price: form.price,
					        extra_credit: form.extra_credit,
					        extra_credit_day: form.extra_credit_day,
							sort: form.sort,
                            is_online: 2,
					    }
					}).then((res) => {
					    this.isSubmiting = false;
					    if (res.code == 0) {
					        this.$Utils.showSuccess(res.msg);
					    } else {
					        this.$Utils.showTipInfo(res.msg);
					    }
					}).catch((err) =>{
					    this.isSubmiting = false;
					});
				} else {
					this.$Rq.requestAuth({
					    url: this.$Api.creditEdit,
					    method: 'post',
					    data: {
					        credit: form.credit,
					        price: form.price,
					        extra_credit: form.extra_credit,
					        extra_credit_day: form.extra_credit_day,
					        sort: form.sort,
                            is_online: 2,
					    }
					}).then((res) => {
					    this.isSubmiting = false;
					    if (res.code == 0) {
					        this.$Utils.showSuccess(res.msg);
					    } else {
					        this.$Utils.showTipInfo(res.msg);
					    }
					}).catch((err) =>{
					    this.isSubmiting = false;
					});
				}
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "CreditEditOffline.scss";
</style>